import { atom, computed, map, type MapStore, type WritableAtom } from 'nanostores';

export type FlowStep = {
  id: string;
  label: string;
  description: string;
  nodeKind: string;
  files: string[];
  position: { x: number; y: number };
  steps: string[];
};

export type Flow = FlowStep[];

export class FlowStore {
  flow: WritableAtom<Flow>;

  activeFlowStep: MapStore<{ step: FlowStep | null; position: { x: number; y: number } | null }> = map({
    step: null,
    position: null,
  });

  constructor() {
    this.flow = atom<FlowStep[]>([]);
  }

  flowStepActive = computed([this.activeFlowStep], (activeStep) => {
    if (activeStep.step?.id) {
      return activeStep.step.id;
    }
    return undefined;
  });

  setActiveFlowStep({ step, position }: { step: FlowStep | null; position: { x: number; y: number } | null }) {
    this.activeFlowStep.set({ step, position });
  }

  addFlowStep(step: FlowStep) {
    this.flow.set([...this.flow.get(), step]);
  }

  addFlow(flow: Flow) {
    this.flow.set([...this.flow.get(), ...flow]);
  }
}
